import React from 'react'
import Flex from '@blocks/Flex'
import { ReactComponent as CheckIcon } from '@icons/check2.svg'
import { ReactComponent as CloseIcon } from '@icons/close.svg'
import styled from 'styled-components'
import { colors } from '@styles/vars'

export default function PastParticipationStatus({ is_accepted }: Props) {
    if (is_accepted)
        return <Flex alignItems="center" gap="10px"><IconWrapper><CheckIcon /></IconWrapper>Accepted</Flex>
    else
        return <Flex alignItems="center" gap="10px"><CloseIcon />Not Accepted</Flex>
}

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background: ${colors.black};
    border-radius: 50%;

    svg {
        fill: ${colors.white};
    }
`

interface Props {
    is_accepted: boolean
}